"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _connect = require("../actions/connect");

var _createPromiseQueue2 = _interopRequireDefault(require("../createPromiseQueue"));

var _setNotification = _interopRequireDefault(require("../actions/setNotification"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(connectionStatusToNotification),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(_callee);

var CONNECTIVITY_STATUS_NOTIFICATION_ID = 'connectivitystatus';

function subscribeToPromiseQueue(observable) {
  var _createPromiseQueue = (0, _createPromiseQueue2["default"])(),
      push = _createPromiseQueue.push,
      shift = _createPromiseQueue.shift;

  var subscription = observable.subscribe({
    next: push
  });
  return {
    shift: shift,
    unsubscribe: function unsubscribe() {
      subscription.unsubscribe();
    }
  };
}

function connectionStatusToNotification(_ref) {
  var directLine, _subscribeToPromiseQu, shift, unsubscribe, reconnecting, value;

  return _regenerator["default"].wrap(function connectionStatusToNotification$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          directLine = _ref.payload.directLine;
          _subscribeToPromiseQu = subscribeToPromiseQueue(directLine.connectionStatus$), shift = _subscribeToPromiseQu.shift, unsubscribe = _subscribeToPromiseQu.unsubscribe;
          _context.prev = 2;

        case 3:
          _context.next = 5;
          return (0, _effects.call)(shift);

        case 5:
          value = _context.sent;
          _context.t0 = value;
          _context.next = _context.t0 === 0 ? 9 : _context.t0 === 1 ? 9 : _context.t0 === 2 ? 12 : _context.t0 === 3 ? 16 : _context.t0 === 4 ? 16 : 20;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)((0, _setNotification["default"])({
            id: CONNECTIVITY_STATUS_NOTIFICATION_ID,
            level: 'info',
            message: reconnecting ? 'reconnecting' : 'connecting'
          }));

        case 11:
          return _context.abrupt("break", 21);

        case 12:
          reconnecting = 1;
          _context.next = 15;
          return (0, _effects.put)((0, _setNotification["default"])({
            id: CONNECTIVITY_STATUS_NOTIFICATION_ID,
            level: 'success',
            message: 'connected'
          }));

        case 15:
          return _context.abrupt("break", 21);

        case 16:
          reconnecting = 1;
          _context.next = 19;
          return (0, _effects.put)((0, _setNotification["default"])({
            id: CONNECTIVITY_STATUS_NOTIFICATION_ID,
            level: 'error',
            message: 'failedtoconnect'
          }));

        case 19:
          return _context.abrupt("break", 21);

        case 20:
          return _context.abrupt("break", 21);

        case 21:
          _context.next = 3;
          break;

        case 23:
          _context.prev = 23;
          unsubscribe();
          return _context.finish(23);

        case 26:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[2,, 23, 26]]);
}

function _callee() {
  return _regenerator["default"].wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_connect.CONNECT, connectionStatusToNotification);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}